import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { SearchOrderTypeEnum } from '@app/features/order-harness/_core/enums';

export const orderHarnessGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
    const router = inject(Router);
    const queryParams = state.root.queryParams;
    const type = queryParams['type'];
    const value = queryParams['value'];

    const validTypes = Object.values(SearchOrderTypeEnum);

    if (validTypes.includes(type) && value) {
        return true;
    }

    router.navigate(['/dashboard']);
    return false;
};
